import React from "react";
function LoadingSpinner() {
  return <div className="loader" data-testid="loading-spinner" />;
}

export default LoadingSpinner;
